import React from "react";
import "./sideObservationMenu.css";
const SideObservationMenu = ({
  selectedObservation,
  setSelectedObservation,
  observations,
}) => {
  return (
    <div className="sideObservationMenuContainer ">
      {observations.map((item, idx) => (
        <div
          key={idx}
          className={`observationItem ${
            selectedObservation === item.observationType ? "active" : ""
          }`}
          onClick={() => setSelectedObservation(item.observationType)}
        >
          <span>{item.observationType}</span>
          <span className="count">{item.objects.length}</span>
        </div>
      ))}
    </div>
  );
};

export default SideObservationMenu;
